// extracted by mini-css-extract-plugin
export default {"productDescription":"k--z","featuredDescription":"l--z","description":"m--z","more":"n--z","descriptionSku":"o--z"};